import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/home/runner/work/qx-lunarheart/qx-lunarheart/app/layouts/default.vue").then(m => m.default || m))
}